import { debounce } from "lodash-es";
import { toObject } from "utils/objects";
import { equals } from "../filters/filterUtils";
import { REQUEST_RESULTS, RECEIVE_RESULTS, LOAD_MORE, RECEIVE_MORE_RESULTS } from "./actionTypes";
import { RECEIVE_LATEST_SHORTLIST_DATA } from "../shortlist/actionTypes";
import { updateContent } from "../content/actions";

import { getAllFilters } from "../filters/selectors";
import {
  getCurrentPage,
  getFilterLookup,
  getQuery,
  getSortBy,
  getSelectedSearchOptionKey,
  getSearchUsageType
} from "../search/selectors";

import { hasContent } from "../content/selectors";
import { updatePage } from "../search/actions";
import { searchConfig } from "../search/searchConfig";
const buildQuery = state => {
  const allFilters = getAllFilters(state);
  let filterQuery = getFilterLookup(state);
  filterQuery = Object.entries(filterQuery).reduce((result, [key, filters]) => {
    const newFilters = filters.map(filter => {
      const filterObj = allFilters.find(f => f.key === key);
      const filterOption = filterObj
        ? filterObj.options.find(o => o.value && equals(o.value, filter))
        : null;
      return filterOption &&
        typeof filter === "string" &&
        filter === filter.toLowerCase() &&
        filterOption.value === filterOption.value.toUpperCase()
        ? decodeURI(encodeURI(filter.toUpperCase()))
        : filter;
    });
    return {
      ...result,
      [key]: newFilters,
    };
  }, {});

  const includeContent = !hasContent(state);
  const searchOption = getSelectedSearchOptionKey(state);
  const page = getCurrentPage(state);
  const sortBy = getSortBy(state);
  const entries = Object.entries({
    ...filterQuery,
    includeContent: includeContent || null,
    journey: searchOption || null,
    page: page > 1 ? page : null,
    [sortBy.key]: sortBy.value || null,
  }).filter(entry => entry[1] !== null);

  const query = toObject(entries);
  return query;
};

const requestResultsThunk = (back) => (dispatch, getState) => {
  const state = getState();
  const query = getQuery(state);
  const dropdownFilters = state.filters.data.allFilters.filter(f => query.filters.map(f => f.key).includes(f.key));
  query.filters.forEach(f => {
    var dropdownFilter = dropdownFilters.find(x => x.key === f.key);
    if(dropdownFilter && typeof f.value === 'string'){
        var dropdownFilterOption = dropdownFilter.options.find(o => o.label?.toUpperCase() === f.value?.toUpperCase().replace('-', ' '));
        if(dropdownFilterOption){
          f.value = dropdownFilterOption.value;
        }
    }
  });
  const apiQuery = buildQuery(state);
  const usageType = getSearchUsageType(state);
  const requestShortlistData = window.sessionStorage.getItem("refreshShortlist");

  dispatch({
    type: REQUEST_RESULTS,
    // loadAll will be true when when user has clicked "Load More" one or more times, went to details page and clicked "back" in the browser
    // we want to show all the cars that they have seen before going to details page
    payload: { ...apiQuery, loadAll:back, usageType: usageType, requestShortlistData: requestShortlistData },
  }).then(response => {
    if (response) {
      dispatch(receiveResults(response.data, query));
    }
  });
};

const debounced = (back) => debounce(requestResultsThunk(back), 500, {
  leading: true,
  trailing: true,
});

export const requestResults = (back) => {
  return debounced(back);
};

export const receiveResults = (results, query) => (dispatch, getState) => {
  const requestShortlistData = window.sessionStorage.getItem("refreshShortlist");
  const shortlist = results.latestShortlistData;
  if (shortlist && requestShortlistData === "true") {
    dispatch({
      type: RECEIVE_LATEST_SHORTLIST_DATA,
      payload: {
        shortlist
      }
    });
  }
  
  if (results.content) {
    dispatch(updateContent(results.content));
  }
  dispatch({
    type: RECEIVE_RESULTS,
    payload: {
      results,
      query,
    },
    meta: {
      updatePageTitle: true,
      updateMetaTag: true,
      updateRobots: true,
      updateCanonical: true,
    },
  });
};

export const receiveMoreResults = results => dispatch => {
  dispatch({
    type: RECEIVE_MORE_RESULTS,
    payload: results,
  });
};

export const loadMore = e => (dispatch, getState) => {
  e.preventDefault();

  const state = getState();
  const query = buildQuery(state);
  const currentPage = getCurrentPage(state);

  const nextPage = currentPage + 1;

  const nextPageQuery = {
    ...query,
    page: nextPage,
  };


  dispatch(updatePage({ page: nextPage }, { ...searchConfig.updateQueryString, replaceState: true }));

  dispatch({
    type: REQUEST_RESULTS,
    payload: nextPageQuery,
    isLoadingMore: true,
  }).then(response => {
    if (response) {
      dispatch(receiveMoreResults(response.data));
    }
  });
};
